import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.scss";

import Header from "components/Layout/Header";
import ButtonBar from "components/ButtonBar";
import PDFViewer from "components/PDFViewer";
import Loading from "components/Loading";
import Modal01 from "components/Modal/Modal01";
import { ekycDelegate } from "module/ekycModule";
import { docsAction, mappingAction } from "module/contractModule";

const CorpDelegation = (props) => {
    const dispatch = useDispatch();
    const estimate        = useSelector((state) => state.contract.estimate);
    const token           = useSelector((state) => state.pass.accessToken);
    const delegationData  = useSelector((state) => state.ekyc.delegationData);
    const isFetching      = useSelector((state) => state.ekyc.isFetching);
    const errorCode       = useSelector((state) => state.ekyc.errorCode);
    const successorGubun  = useSelector((state) => state.ekyc.successorGubun);
    const isMidEnrollment = useSelector((state) => state.contract.isMidEnrollment);
    const corpAuthType    = useSelector((state) => state.ekyc.corpAuthType);
    const contractDocsList = useSelector((state) => state.contract.docsList);
    const contractMapping  = useSelector((state) => state.contract.mapping);

    const [scale, setScale] = useState(1);
    const [errorModal, setErrorModal] = useState(false);

    useEffect(() => {
        if (!estimate) {
            props.history.push("/auth/contractNum");
            return;
        }

        if (corpAuthType !== "delegate") {
            props.history.replace("/");
            return;
        }

        const isSuccessor = successorGubun !== "";

        dispatch(ekycDelegate.get.request({
            estimate:      isSuccessor ? undefined : estimate,
            vbeln:         isSuccessor ? estimate  : undefined,
            successorGubun,
            isMid:         isMidEnrollment,
            token,
        }));

        const w = window.innerWidth || document.documentElement.clientWidth;
        let _scale = 1;
        if (w < 451) _scale = 0.6;
        else if (w < 1025) _scale = 0.8;
        else if (w < 1367) _scale = 1;
        else _scale = 1.4;
        setScale(_scale);
    }, []);

    useEffect(() => {
        if (errorCode === "DELEGATE_FAIL") {
            setErrorModal(true);
        }
    }, [errorCode]);

    useEffect(() => {
        if (!successorGubun || !delegationData?.docsList?.length || !contractDocsList) return;
        const alreadyAdded = delegationData.docsList.some(id => contractDocsList.includes(id));
        if (alreadyAdded) return;

        const offset = contractDocsList.length;
        dispatch(docsAction.post.request([...contractDocsList, ...delegationData.docsList]));
        dispatch(mappingAction.post.request([
            ...(contractMapping || []),


            ...(delegationData.signConditions || []).map(sc => ({ ...sc, docIdx: sc.docIdx + offset })),
        ]));
    }, [delegationData]);

    return (
        <>
            <Header onClick={() => props.history.push("/")} />
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <h1 className={styles.title}>업무대리인 위임장 확인</h1>
                        <p className={styles.desc}>
                            아래 위임장 내용을 확인 후 본인인증을 진행해주세요.
                        </p>
                        <div className={styles.pdfWrap}>
                            {isFetching ? (
                                <Loading />
                            ) : (
                                <PDFViewer
                                    referer="templateEdit"
                                    docs={(delegationData?.docsList || []).map((docsId) => ({ docs: `/api/v1/template/docs/${docsId}`, pages: 1 }))}
                                    fieldDataList={(delegationData?.signConditions || []).map((item) => ({
                                        ...item,
                                        doc:   { idx: item.docIdx, page: item.docPage },
                                        type:  item.coordType,
                                        style: { height: item.height, width: item.width },
                                    }))}
                                    fieldDataOrigin={(delegationData?.signConditions || []).map((item) => ({
                                        ...item,
                                        doc:   { idx: item.docIdx, page: item.docPage },
                                        type:  item.coordType,
                                        style: { height: item.height, width: item.width },
                                    }))}
                                    scale={scale}
                                    showField={true}
                                    isSigning={false}
                                    type="bigView"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ButtonBar
                oneBtn
                leftBtnTxt="본인인증 진행"
                leftBtnFunc={() => props.history.push("/ekyc/start")}
            />

            <Modal01
                open={errorModal}
                close={() => {
                    setErrorModal(false);
                    props.history.goBack();
                }}
                header="안내"
            >
                위임장 정보를 불러오는 데 실패했습니다.<br />
                이전 화면으로 돌아갑니다.
            </Modal01>
        </>
    );
};

export default CorpDelegation;
